const REG_EXP = /[\d.\-+]*\s*(.*)/

const BASE_FONT_SIZE = 16

const unitLess = (length: string) => parseFloat(length)

type Unit = 'em' | 'px' | 'rem' | 'ex'

export function toCssSizePx(length: string): number {
  const fromUnit = length.match(REG_EXP)[1] || ''

  let pxLength = unitLess(length)

  if (fromUnit === 'em') {
    pxLength = unitLess(length) * BASE_FONT_SIZE
  } else if (fromUnit === 'rem') {
    pxLength = unitLess(length) * BASE_FONT_SIZE
  } else if (fromUnit === 'ex') {
    pxLength = unitLess(length) * BASE_FONT_SIZE * 2
  }
  return pxLength
}

export function toCssSize(length: string, toUnit: Unit) {
  const fromUnit = length.match(REG_EXP)[1] || ''

  if (fromUnit === toUnit) {
    return length
  }

  const pxLength = toCssSizePx(length)

  let outputLength = pxLength
  if (toUnit !== 'px') {
    if (toUnit === 'em') {
      outputLength = pxLength / BASE_FONT_SIZE
    } else if (toUnit === 'rem') {
      outputLength = pxLength / BASE_FONT_SIZE
    } else if (toUnit === 'ex') {
      outputLength = pxLength / BASE_FONT_SIZE / 2
    } else {
      return length
    }
  }

  return parseFloat(outputLength.toFixed(5)) + toUnit
}
